export const data = [
    {
        title : "Tujuan Pembelajaran",
        sub : [
            {
                no : "1)",
                word : "Siswa dapat menyelesaikan pertidaksamaan linear dua variabel."
            },
            {
                no : "2)",
                word : "Siswa dapat menentukan daerah penyelesaian dari sistem pertidaksamaan linear dua variabel."
            },
            {
                no : "3)",
                word : "Siswa dapat menentukan pertidaksamaan dari daerah suatu sistem pertidaksamaan linear dua variabel"
            }

        ],
        
        subbab1 : "A. Mengenal Pertidaksamaan Linear Dua Variabel",
        wordmateri : "Pertidaksamaan linear dua variabel merupakan suatu kalimat terbuka matematika yang di dalamnya memuat dua variabel. Dengan masing-masing variabel berderajat satu serta dihubungkan dengan tanda ketidaksamaan. Tanda ketidaksamaan yang dimaksud disini antara lain >, <, ≤, atau ≥. Bentuk umum pertidaksamaan linear dua variabel yaitu:",
        bupert : `di mana x dan y adalah variabel,a dan b adalah koefisien c adalah konstanta dengan x & y anggota R`,
        tanda : ">, <, ≤, atau ≥"
         
    },
    {
        subbab2 :"B.Penyelesaian Pertidaksamaan Linear Dua Variabel",
        materi2 : "Penyelesaian dari pertidaksamaan linear dua variabel adalah dimana nilai x dan y yang memenuhi dari pertidaksamaan. Berikut langkah menyelesaiakan pertidaksamaan linear dua variabel : "
    },
    {
        subbab3 :"C. Sistem Pertidaksamaan Linear Dua Variabel",
        materi3 :"Apakah kalian mengetahui perbedaan dari pertidaksamaan linear dan sistem pertidaksamaan linear? Perbedaan dari keduanya terletak pada banyaknya pertidaksamaan. Pada sistem pertidaksamaan linear, misalnya pada sistem pertidaksamaan linear dua variabel, terdapat lebih dari satu pertidaksamaan linear dua variabel agar dapat dibuat model matematika dan ditentukan solusinya. Maka penyelesaian dari sistem pertidaksamaan linear dua variabel merupakan irisan dari penyelesaian pertidaksamaan dalam sistem tersebut. "
    },
    
]